

import Vue from 'vue'
import App from './App.vue'
//import './registerServiceWorker'
import router from './router'
import store from './store'

import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'

// LuxPro STYLES
// Main Theme SCSS
import './assets/luxpro/scss/theme.scss'

// Amplify UI custom styling
import './assets/amplify/style.css'

import '@aws-amplify/ui-vue';
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

import VueClipboard from 'vue-clipboard2'
import VueGtm from '@gtm-support/vue2-gtm';

import './plugins/apexcharts'


Vue.use(VueClipboard)

//console.debug(`Initiating GTAG with ID ${process.env.VUE_APP_GTAG}`);
if(process.env.VUE_APP_GTAG && process.env.VUE_APP_GTAG != 'disable') {
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTAG, 
  vueRouter: router
});
}

Amplify.configure(awsconfig);

Vue.config.productionTip = false

new Vue({
  i18n,
  vuetify: vuetify(i18n),
  router,
  store,
  render: h => h(App)
}).$mount('#app')
